import { render, staticRenderFns } from "./PatientAgreeList.vue?vue&type=template&id=a7196b14&scoped=true&"
import script from "./PatientAgreeList.vue?vue&type=script&lang=js&"
export * from "./PatientAgreeList.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/page/patientAgreeList.css?vue&type=style&index=0&id=a7196b14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7196b14",
  null
  
)

export default component.exports